import axios from 'axios';
import {
    DELETE_DRIVER,
    GET_DRIVER,
    GET_DRIVERS,
    POST_DRIVER,
    UPDATE_DRIVER,
    GET_DRIVER_MESSAGES
} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_DRIVERS, options);
    },
    async get(driver, options = {}) {
        return await axios.get(GET_DRIVER(driver), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_DRIVER, data, options);
    },
    async update(driver, options = {}) {
        return await axios.patch(UPDATE_DRIVER(driver), options);
    },
    async delete(driver, options = {}) {
        return await axios.delete(DELETE_DRIVER(driver), options);
    },
    async get_messages() {
        return await axios.get(GET_DRIVER_MESSAGES)
    }
};
